<template>
  <div class="mb-10">
    <v-breadcrumbs :items="breadcrumbs_items" large></v-breadcrumbs>
    <v-container>

      <h1 class="headline font-weight-light mb-2">
        Формирование заявления
      </h1>
      <v-stepper v-model="step" vertical class="pb-4">

        <!------------>
        <!-- STEP 1 -->
        <!------------>

        <v-stepper-step :editable="step > 1" color="indigo" :complete="step > 1" step="1">Образовательное
          учреждение
        </v-stepper-step>
        <v-stepper-content :v-if="step === 1" step="1">
          <v-card>
            <v-card-subtitle>
              <p class="mb-0">Выберите образовательную организацию в которую хотите подать заявление о приеме</p>
            </v-card-subtitle>
            <v-card-text>
              <campaign-select
                ref="campaignSelect"
                :campaigns="campaigns"
              ></campaign-select>
            </v-card-text>
            <v-card-actions>
              <v-btn
                class="lighten-1"
                color="indigo"
                dark
                @click="fromStep1">
                Далее
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>

        <!------------>
        <!-- STEP 2 -->
        <!------------>

        <v-stepper-step :editable="step > 2" color="indigo" :complete="step > 2" step="2">
          Уровень и форма образования
        </v-stepper-step>
        <v-stepper-content :v-if="step === 2" step="2">
          <v-card>
            <v-card-subtitle>
              <p class="mb-0">Выберите образовательный уровень и форму обучения</p>
            </v-card-subtitle>
            <v-card-text>
              <application-type-select
                ref="typeSelect"
                :application-types="application_types"
              >
              </application-type-select>
            </v-card-text>
            <v-card-actions>
              <v-btn
                class="lighten-1"
                color="indigo"
                dark
                @click="fromStep2">
                Далее
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>

        <!------------>
        <!-- STEP 3 -->
        <!------------>

        <v-stepper-step :editable="step > 3" color="indigo" :complete="step > 3" step="3">
          Заявление
        </v-stepper-step>
        <v-stepper-content :v-if="step === 3" step="3">
          <v-card flat>

            <v-card-text>
              <ol>
                <li class="mb-2">Ознакомьтесь со
                  <a class="font-weight-regular indigo--text"
                     v-bind:href="getFile('kcp')"
                     target="_blank"
                  >списком</a> специальностей и направлений подготовки и контрольными цифрами приема (КЦП), на которые
                  ведется набор в
                  «Кузбасский государственный технический университет имени Т.Ф. Горбачева» и примером формирования списка специальностей (направлений подготовки) для включения в заявление.
                </li>
                <li class="mb-2">
                  <a class="font-weight-regular indigo--text"
                     v-bind:href="getFile('application')"
                     target="_blank"
                  >Скачайте</a>
                  и распечатайте бланк заявления.
                </li>
                <li class="my-2">
                  Заполните
                  (согласно <a class="font-weight-regular indigo--text"
                               v-bind:href="getFile('application_example')"
                               target="_blank"
                >образцу</a>)
                  <v-tooltip bottom max-width="600">
                    <template v-slot:activator="{ on, attrs }">
                      <span class="text--secondary" v-bind="attrs" style="border-bottom: 1px dashed" v-on="on">собственноручно</span>
                    </template>
                    <span>
                      Заполняется рукописным способом разборчиво (печатными буквами) чернилами черного либо синего цвета.
                      Опечатки, подчистки, приписки, зачеркнутые слова и иные исправления не допускаются.
                    </span>
                  </v-tooltip>
                  все поля и заверьте заявление личными подписями с расшифровками.
                  <div class="mt-1">Обратите внимание:</div>
                  <ul>
                    <li>Список специальностей (направлений подготовки) указывайте вместе с выбраной вами формой обучения.<br>
                      В рамках одного заявления вы можете выбрать несколько форм обучения.<br>
                      Например:<br>
                      1. <span style="font-weight: bold">21.05.04 ГД Горное дело (очная)</span><br>
                      2. <span style="font-weight: bold">21.03.02 ГК Землеустройство и кадастры (заочная)</span><br>
                      3. <span style="font-weight: bold">09.03.02 ИС Информационные системы и технологии (очная)</span><br>
                      ...
                    </li>
                  </ul>
                </li>
                <li>Создайте
                  <v-tooltip bottom max-width="600">
                    <template v-slot:activator="{ on, attrs }">
                      <span class="text--secondary" v-bind="attrs" style="border-bottom: 1px dashed" v-on="on">электронную копию</span>
                    </template>
                    Фотография с телефона или скан-копия документа.
                    Качество изображений должно обеспечивать читаемость информации.
                    Допустимые форматы: .png, .jpg, .jpeg или .pdf, максимальный размер на один файл: 20МБ.
                  </v-tooltip>
                  заявления и прикрепите в поле "Выбрать файл".
                </li>
              </ol>
            </v-card-text>
<!--            <v-card-text v-if="application.application_type && [1, 2, 8].includes(application.application_type.id)">-->
<!--              <v-expansion-panels flat>-->
<!--                <v-expansion-panel class="text&#45;&#45;secondary text-body-2">-->
<!--                  <p class="mb-0">-->
<!--                    <v-icon color="info">{{ icons.mdiInformationVariant }}</v-icon>-->
<!--                    <span class="font-italic">Дополнительная информация</span>:-->
<!--                  </p>-->
<!--                  <v-expansion-panel-header class="text-body-2">Сдача вступительных испытаний, проводимых КузГТУ-->
<!--                    самостоятельно,-->
<!--                    для категорий граждан, имеющих на это право-->
<!--                  </v-expansion-panel-header>-->
<!--                  <v-expansion-panel-content>-->
<!--                    <div class="text-justify">-->
<!--                      <p>-->
<!--                        Отдельные категории поступающих на базе среднего общего образования-->
<!--                        могут по своему усмотрению поступать на обучение по результатам-->
<!--                        общеобразовательных вступительных испытаний, проводимых КузГТУ-->
<!--                        самостоятельно:-->
<!--                      </p>-->
<!--                      <ul>-->
<!--                        <li>лица с ограниченными возможностями здоровья, дети-инвалиды, инвалиды;</li>-->
<!--                        <li>иностранные граждане;</li>-->
<!--                        <li>лица, прошедшие государственную итоговую аттестацию по-->
<!--                          образовательным программам среднего общего образования не в форме ЕГЭ-->
<!--                          (в том числе в иностранных образовательных организациях) в течение 1 года-->
<!--                          до дня завершения приема документов и вступительных испытаний-->
<!--                          включительно.-->
<!--                        </li>-->
<!--                      </ul>-->
<!--                    </div>-->
<!--                  </v-expansion-panel-content>-->
<!--                </v-expansion-panel>-->
<!--              </v-expansion-panels>-->
<!--            </v-card-text>-->
            <v-card-text>
              <file-input
                ref="type5Files"
                :type="5"
                :application="application"
                :max-files="5"
              ></file-input>
            </v-card-text>


            <v-card-text>
              <p>Обучение по контракту</p>
              <v-switch
                v-model="is_contract"
                label="В заявлении мной дано согласие на участие в конкурсе на места по договорам об оказании платных образовательных услуг"
              ></v-switch>
            </v-card-text>

            <template v-if="is_contract">
              <v-card-text>
                <p>Выберите вид договора на обучение с оплатой:</p>
                <contract-type-radio ref="contractType"></contract-type-radio>
              </v-card-text>
            </template>
            <v-card-actions>
              <v-btn
                dark
                class="lighten-1"
                color="indigo"
                @click="fromStep3"
                :loading="isLoading"
              >
                Далее
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>


        <!------------>
        <!-- STEP 4 -->
        <!------------>

        <v-stepper-step
          :editable="step > 4 && application.application_type && [1,2,8,9].includes(application.application_type.id)"
          color="indigo"
          :complete="step > 4 && application.application_type && [1,2,8,9].includes(application.application_type.id)"
          step="4"
        >
          Приоритетность образовательных программ
        </v-stepper-step>
        <v-stepper-content
          :v-if="step === 4 && application.application_type && [1,2,8,9].includes(application.application_type.id)"
          step="4">
          <v-card flat>
            <v-card-text>
              <ol>
                <li class="mb-2">
                  <a class="font-weight-regular indigo--text"
                     v-bind:href="getFile('priority')"
                     target="_blank"
                  >Скачайте</a>
                  и распечатайте бланк приоритетности образовательных программ.
                </li>
                <li class="my-2">
                  Заполните
                  (согласно <a class="font-weight-regular indigo--text"
                               v-bind:href="getFile('priority_example')"
                               target="_blank"
                >образцу</a>)
                  <v-tooltip bottom max-width="600">
                    <template v-slot:activator="{ on, attrs }">
                      <span class="text--secondary" v-bind="attrs" style="border-bottom: 1px dashed" v-on="on">собственноручно</span>
                    </template>
                    <span>
                      Заполняется рукописным способом разборчиво (печатными буквами) чернилами черного либо синего цвета.
                      Опечатки, подчистки, приписки, зачеркнутые слова и иные исправления не допускаются.
                    </span>
                  </v-tooltip>
                  все поля и заверьте документ личной подписью с расшифровкой.
                </li>
                <li>Создайте
                  <v-tooltip bottom max-width="600">
                    <template v-slot:activator="{ on, attrs }">
                      <span class="text--secondary" v-bind="attrs" style="border-bottom: 1px dashed" v-on="on">электронную копию</span>
                    </template>
                    Фотография с телефона или скан-копия документа.
                    Качество изображений должно обеспечивать читаемость информации.
                    Допустимые форматы: .png, .jpg, .jpeg или .pdf, максимальный размер на один файл: 20МБ.
                  </v-tooltip>
                  документа и прикрепите в поле "Выбрать файл".
                </li>
              </ol>
            </v-card-text>


<!--            <v-card-text>-->
<!--              <v-switch-->
<!--                class="mb-0"-->
<!--                v-model="is_help_education_programs"-->
<!--                label="Я поступаю на бюджет и не понимаю как заполнить бланк приоритетности образовательных программ"-->
<!--              ></v-switch>-->
<!--              <template v-if="is_help_education_programs">-->
<!--                <p>Конструктор бланка приоритетности образовательных программ:</p>-->
<!--                <ol>-->
<!--                  <li>Выберите поочередно специальности, направления подготовки, которые вы указали в вашем заявлении;</li>-->
<!--                  <li>После выбора ниже автоматически появится список образовательных программ;</li>-->
<!--                  <li>Отсортируйте список образовательных программ перетаскивая между собой строки (если образовательная программа одна сортировать ее не нужно);</li>-->
<!--                  <li>Нажмите кнопку "Сформировать приоритетность" и перепишите в бланк приоритетности образовательных программ сформированную информацию;</li>-->
<!--                  <li>Прикрепите бланк.</li>-->
<!--                </ol>-->

<!--                <education-programs-->
<!--                  v-if="application.campaign && application.application_type"-->
<!--                  :campaign_id="application.campaign.id"-->
<!--                  :application_type_id="application.application_type.id"-->
<!--                  :select_number="application.application_type.id === 9 ? 8 : 3"-->
<!--                  :step="step"-->
<!--                >-->
<!--                </education-programs>-->
<!--              </template>-->
<!--            </v-card-text>-->


            <v-card-text>
              <file-input
                ref="type7Files"
                :type="7"
                :application="application"
                :max-files="1"
              ></file-input>

            </v-card-text>
            <v-card-actions>
              <v-btn
                dark
                class="lighten-1"
                color="indigo"
                @click="fromStep4"
                :loading="isLoading"
              >Далее
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>

        <!------------>
        <!-- STEP 5 -->
        <!------------>

        <v-stepper-step
          :editable="step > 5 && application.application_type && [1,2,8].includes(application.application_type.id)"
          color="indigo"
          :complete="step > 5 && application.application_type && [1,2,8].includes(application.application_type.id)"
          step="5"
        >
          Особые права или льготы
        </v-stepper-step>
        <v-stepper-content
          :v-if="step === 5 && application.application_type && [1,2,8].includes(application.application_type.id)"
          step="5">
          <v-card flat>
            <v-card-text>
              <p>Если вы относитесь к категории граждан, имеющих в соответствии с
                <span class="font-weight-bold">Правилами приема в КузГТУ</span>
                право на поступление в пределах особой или отдельной квоты или преимущество при зачислении, активируйте поле
                "У меня особые права или льготы":</p>
            </v-card-text>
            <v-card-text class="py-0">
              <v-switch v-model="priority_agree">
                <template v-slot:label>
                  У меня особые права или льготы
                </template>
              </v-switch>
            </v-card-text>
            <div v-if="priority_agree">
              <v-card-subtitle>
                <p>
                  Для перечисленных ниже категорий создайте
                  <v-tooltip bottom max-width="600">
                    <template v-slot:activator="{ on, attrs }">
                      <span class="text--secondary" v-bind="attrs" style="border-bottom: 1px dashed" v-on="on">электронную копию</span>
                    </template> имеющегося у вас
                    Фотография с телефона или скан-копия документа.
                    Качество изображений должно обеспечивать читаемость информации.
                    Допустимые форматы: .png, .jpg, .jpeg или .pdf, максимальный размер на один файл: 20МБ.
                  </v-tooltip>
                  подтверждающего документа, из перечисленных ниже, название документа указано в скобках, и прикрепите в поле "Выбрать файл".
                </p>
                <ul>
                  <li>
                    ребенок-инвалид, инвалид I и II групп, инвалид с детства, инвалид
                    вследствие военной травмы или заболевания, полученных в период
                    прохождения военной службы (справка МСЭ);
                  </li>
                  <li>
                    ребенок-сирота и ребенок, оставшийся без попечения родителей, лицо из
                    числа детей-сирот и детей, оставшихся без попечения родителей (справка о
                    статусе сироты из органов опеки);
                  </li>
                  <li>
                    ветеран боевых действий из числа лиц,указанных в подпунктах 1-4
                    пункта 1 статьи 3 Федерального закона от 12 января 1995 года N 5-ФЗ "О
                    ветеранах" (удостоверение ветерана боевых действий).
                  </li>
                </ul>
                <p class="mt-3 mb-0">Все остальные категории граждан, имеющих особые права или льготы, прикрепляют
                  скан-копию
                  подтверждающего документа (справка, удостоверение).</p>
              </v-card-subtitle>
              <v-card-text>
                <file-input
                  ref="type9Files"
                  :type="9"
                  :max-files="5"
                  :application="application"
                ></file-input>
              </v-card-text>
            </div>

            <v-card-actions>
              <v-btn
                dark
                class="lighten-1"
                color="indigo"
                @click="fromStep5"
                :loading="isLoading"
              >
                Далее
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>

        <!------------>
        <!-- STEP 6 -->
        <!------------>

        <v-stepper-step :editable="step > 6" color="indigo" :complete="step > 6" step="6">
          Индивидульные достижения
        </v-stepper-step>
        <v-stepper-content :v-if="step === 6" step="6">
          <v-card flat>
            <v-card-subtitle v-if="application.application_type && [9].includes(application.application_type.id)">
              <p>При наличии у вас документов, подтверждающих индивидуальные достижения в соответствии с
                <a class="font-weight-regular indigo--text"
                   v-bind:href="'https://kuzstu.ru/abitur/abiturient2k20/secondary-professional-education-spo/t_pravila_priema.pdf'"
                   target="_blank"
                >Правилами приема в КузГТУ</a>,
                активируйте поле "У меня есть индивидуальные достижения":</p>
              <ul>
                <li class="mb-1">Диплом победителя или призёра олимпиады школьников, чемпионата по профмастерству
                  (достаточно одного
                  документа)
                </li>
                <li class="mb-1">Сертификат участника летней инженерной школы КузГТУ или сертификат о профессиональных
                  пробах (достаточно одного документа)
                </li>
                <li class="mb-1">Документ, подтверждающий наличие Золотого значка ГТО (удостоверение)</li>
              </ul>
            </v-card-subtitle>
            <v-card-subtitle
              v-else-if="application.application_type && [3,4,7].includes(application.application_type.id)">
              <p>При наличии у вас документов, подтверждающих индивидуальные достижения в соответствии с
                <span class="font-weight-bold">Правилами приема в КузГТУ</span>, активируйте поле &laquo;У меня есть
                индивидуальные достижения&raquo;:</p>
              <ul>
                <li class="mb-1">Диплом победителя или призёра студенческих олимпиад (достаточно одного документа)</li>
                <li class="mb-1">Публикации в научных изданиях (титульный лист издания - достаточно одного)</li>
              </ul>
              <p class="mt-5 mb-0">
                <small>
                  Примечание:<br>Сведения о наличии диплома с отличием учитываются на основании копии
                  соответствующего документа, представленной в разделе "Документ о предыдущем образовании"
                  - активировать поле "У меня есть индивидуальные достижения" не нужно.
                </small>
              </p>
            </v-card-subtitle>
            <v-card-subtitle v-else>
              <p>При наличии у вас документов, подтверждающих индивидуальные достижения в соответствии с Правилами
                приема в КузГТУ, активируйте поле &laquo;У меня есть индивидуальные достижения&raquo;.</p>
<!--              <ul>-->
<!--                <li class="mb-1">Диплом победителя или призёра олимпиады, конкурса, чемпионата по профмастерству-->
<!--                  (достаточно одного-->
<!--                  документа)-->
<!--                </li>-->
<!--                <li class="mb-1">Документ, подтверждающий наличие спортивных достижений или Золотого значка ГТО-->
<!--                  (достаточно-->
<!--                  одного)-->
<!--                </li>-->
<!--              </ul>-->
<!--              <p class="mt-5 mb-0">-->
<!--                <small>-->
<!--                  Примечание:<br>Сведения о наличии диплома или аттестата с отличием учитываются на основании копии-->
<!--                  соответствующего документа, представленной в разделе &laquo;Документ о предыдущем образовании&raquo;-->
<!--                  &mdash; активировать поле &laquo;У меня есть индивидуальные достижения&raquo; не нужно.-->
<!--                </small>-->
<!--              </p>-->
            </v-card-subtitle>
            <v-card-text class="py-0">
              <v-switch v-model="progress_agree">
                <template v-slot:label>
                  У меня есть индивидуальные достижения
                </template>
              </v-switch>
            </v-card-text>
            <div v-if="progress_agree">
              <v-card-subtitle>
                Создайте
                <v-tooltip bottom max-width="600">
                  <template v-slot:activator="{ on, attrs }">
                    <span class="text--secondary" v-bind="attrs" style="border-bottom: 1px dashed" v-on="on">электронную копию</span>
                  </template>
                  Фотография с телефона или скан-копия документа.
                  Качество изображений должно обеспечивать читаемость информации.
                  Допустимые форматы: .png, .jpg, .jpeg или .pdf, максимальный размер на один файл: 20МБ.
                </v-tooltip>
                подтверждающего документа (документов) и прикрепите в поле "Выбрать файл".
              </v-card-subtitle>
              <v-card-text>
                <file-input
                  ref="type14Files"
                  :type="14"
                  :max-files="10"
                  :application="application"
                ></file-input>
              </v-card-text>
            </div>

            <v-card-actions>
              <v-btn
                dark
                class="lighten-1"
                color="indigo"
                @click="fromStep6"
                :loading="isLoading"
              >
                Далее
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>

        <!------------>
        <!-- STEP 7 -->
        <!------------>

        <v-stepper-step :editable="step > 7" color="indigo" :complete="step > 7" step="7">
          Целевое обучение
        </v-stepper-step>
        <v-stepper-content :v-if="step === 7" step="7">
          <v-card flat>
            <v-card-text class="py-0">
              <v-switch v-model="target_agree">
                <template v-slot:label>
                  У меня есть заявка на целевое обучение
                </template>
              </v-switch>
            </v-card-text>
            <div v-if="target_agree">
              <v-card-subtitle>
                Создайте
                <v-tooltip bottom max-width="600">
                  <template v-slot:activator="{ on, attrs }">
                    <span class="text--secondary" v-bind="attrs" style="border-bottom: 1px dashed" v-on="on">электронную копию</span>
                  </template>
                  Фотография с телефона или скан-копия документа.
                  Качество изображений должно обеспечивать читаемость информации.
                  Допустимые форматы: .png, .jpg, .jpeg или .pdf, максимальный размер на один файл: 20МБ.
                </v-tooltip>
                заявка на целевое обучение и прикрепите в поле "Выбрать файл".
              </v-card-subtitle>
              <v-card-text>
                <file-input
                  ref="type10Files"
                  :type="10"
                  :max-files="1"
                  :application="application"
                ></file-input>
              </v-card-text>
            </div>

            <v-card-actions>
              <v-btn
                dark
                class="lighten-1"
                color="indigo"
                @click="fromStep7"
                :loading="isLoading"
              >
                Далее
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>

        <!------------>
        <!-- STEP 8 -->
        <!------------>

        <v-stepper-step :editable="step > 8" color="indigo" :complete="step > 8" step="8">
          Отправка заявления
        </v-stepper-step>
        <v-stepper-content :v-if="step === 8" step="8">
          <v-card flat>

            <v-card-text>
              Формирование заявления завершено, можно отправить его в приемную комиссию.
            </v-card-text>

            <v-card-actions>
              <v-btn
                dark
                class="lighten-1"
                color="indigo"
                @click="submit"
                :loading="isLoading"
              >
                Отправить
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>


      </v-stepper>
    </v-container>


    <!--        <education-programs-->
    <!--          :campaign_id="campaign"-->
    <!--          :application_type_id="application_type"-->
    <!--          :select_number="3"-->
    <!--        >-->
    <!--        </education-programs>-->


  </div>
</template>

<script>
import {mapGetters} from "vuex";
import CampaignSelect from "@/components/profile/application/create/CampaignSelect";
import ApplicationTypeSelect from "@/components/profile/application/create/ApplicationTypeSelect";
import FileInput from "@/components/profile/FileInput";
import {
  mdiCamera,
  mdiClose,
  mdiFileDocument,
  mdiInformationVariant,
  mdiPrinter,
  mdiSchool,
  mdiTextBoxCheckOutline,
} from "@mdi/js";
import ContractTypeRadio from "../../../components/profile/application/create/ContractTypeRadio";
import {urls} from "@/_services/blank_file"
// import EducationPrograms from "@/components/profile/application/create/EducationPrograms";

export default {
  name: "CreateApplication",
  components: {ContractTypeRadio, FileInput, ApplicationTypeSelect, CampaignSelect},
  data() {
    return {
      icons: {
        mdiSchool,
        mdiClose,
        mdiFileDocument,
        mdiPrinter,
        mdiCamera,
        mdiTextBoxCheckOutline,
        mdiInformationVariant,
      },
      breadcrumbs_items: [
        {text: 'Мои заявления', disabled: false, to: {name: 'profile_application_list'}},
        {text: 'Заявление', disabled: true},
      ],
      documents: [],
      is_help_education_programs: false,
    };
  },
  async created() {
    await this.$store.dispatch('campaign/loadCampaigns')
    if (this.abiturient.current_application_id) {
      await this.$store.dispatch("application/retrieveApplication", this.abiturient.current_application_id)
        .then(() => {
          this.$store.dispatch('application_type/loadApplicationTypes', this.application)
        })
    } else {
      await this.$store.dispatch("application/createApplication")
        .then(() => {
          this.$store.dispatch('application_type/loadApplicationTypes', this.application)
          this.$store.commit("abiturient/UPDATE_ABITURIENT_MODEL", {current_application_id: this.application.id})
          this.$store.dispatch("abiturient/update")
        })
    }

    if (this.application.campaign && this.application.application_type) {
      if (this.application.campaign.id in urls && this.application.application_type.id in urls[this.application.campaign.id]) {
        this.documents = urls[this.application.campaign.id][this.application.application_type.id]
      }
    }
  },
  computed: {
    ...mapGetters("campaign", ["campaigns"]),
    ...mapGetters("application_type", ["application_types"]),
    ...mapGetters("application", ["application"]),
    ...mapGetters("abiturient", ["abiturient"]),
    ...mapGetters("context", ['isLoading']),
    step: {
      get() {
        return this.abiturient.current_application_step
      },
      set(value) {
        this.$store.commit("abiturient/UPDATE_ABITURIENT_MODEL", {current_application_step: value})
        this.$store.dispatch("abiturient/update")
      }
    },
    is_contract: {
      get() {
        return this.application.is_contract
      },
      set(value) {
        this.$store.commit("application/CHANGE_APPLICATION", {is_contract: value})
        this.$store.dispatch("application/updateApplication")
      }
    },
    priority_agree: {
      get() {
        return this.abiturient.priority_agree
      },
      set(value) {
        this.$store.commit("abiturient/UPDATE_ABITURIENT_MODEL", {priority_agree: value})
        this.$store.dispatch("abiturient/update")
      }
    },
    progress_agree: {
      get() {
        return this.abiturient.progress_agree
      },
      set(value) {
        this.$store.commit("abiturient/UPDATE_ABITURIENT_MODEL", {progress_agree: value})
        this.$store.dispatch("abiturient/update")
      }
    },
    target_agree: {
      get() {
        return this.abiturient.target_agree
      },
      set(value) {
        this.$store.commit("abiturient/UPDATE_ABITURIENT_MODEL", {target_agree: value})
        this.$store.dispatch("abiturient/update")
      }
    },
  },
  watch: {
    step() {
      if (this.application.campaign && this.application.application_type) {
        if (this.application.campaign.id in urls && this.application.application_type.id in urls[this.application.campaign.id]) {
          this.documents = urls[this.application.campaign.id][this.application.application_type.id]
        }
      }
    },
    application() {
      if (this.application.campaign) {
        this.$store.dispatch('application_type/loadApplicationTypes', this.application)
      }
    },
  },
  methods: {
    getFile(name) {
      return this.documents[name]
    },
    // Образовательное учреждение
    async fromStep1() {
      const campaignSelect = this.$refs.campaignSelect
      await campaignSelect.submit().then(() => {
        if (campaignSelect.isSuccess) {
          this.step = 2
          campaignSelect.isSuccess = false
        }
      })
    },

    // Уровень и форма образования
    async fromStep2() {
      const typeSelect = this.$refs.typeSelect
      await typeSelect.submit().then(() => {
        if (typeSelect.isSuccess) {
          this.step = 3
          typeSelect.isSuccess = false
        }
      })
    },

    // Заявление
    async fromStep3() {
      let appSuccess = false
      let contractSuccess = true

      const fileInput = this.$refs.type5Files
      await fileInput.validateFiles().then(() => {
        if (fileInput.isSuccess) {
          fileInput.isSuccess = false
          appSuccess = true
        }
      })

      if (this.is_contract) {
        contractSuccess = false

        const contractType = this.$refs.contractType
        if (parseInt(contractType.contract_type) === 1) {
          contractSuccess = true
        } else if (parseInt(contractType.contract_type) === 2) {
          const contractFileInput1 = contractType.$refs.type101Files
          const contractFileInput2 = contractType.$refs.type102Files

          await Promise.all([
            contractFileInput1.validateFiles(),
            contractFileInput2.validateFiles(),
          ]).finally(() => {
            if (contractFileInput1.isSuccess && contractFileInput2.isSuccess) {
              contractFileInput1.isSuccess = false
              contractFileInput2.isSuccess = false
              contractSuccess = true
            }
          })

        } else if (parseInt(contractType.contract_type) === 3) {
          const contractFileInput3 = contractType.$refs.type103Files
          await contractFileInput3.validateFiles().then(() => {
            if (contractFileInput3.isSuccess) {
              contractFileInput3.isSuccess = false
              contractSuccess = true
            }
          })
        }
      }

      if (appSuccess && contractSuccess) {
        if (![1, 2, 8, 9].includes(this.application.application_type.id)) {
          this.step = 6
        } else {
          this.step = 4
        }
      }
    },

    // Приоритетность образовательных программ
    async fromStep4() {
      const fileInput = this.$refs.type7Files
      await fileInput.validateFiles().then(() => {
        if (fileInput.isSuccess) {
          this.step = 5
          fileInput.isSuccess = false
        }
      })
    },

    // Особые права и льготы
    async fromStep5() {
      if (this.priority_agree) {
        const fileInput = this.$refs.type9Files
        await fileInput.validateFiles().then(() => {
          if (fileInput.isSuccess) {
            this.step = 6
            fileInput.isSuccess = false
          }
        })
      } else {
        this.step = 6
      }
    },

    // Индивидульные достижения
    async fromStep6() {
      if (this.progress_agree) {
        const fileInput = this.$refs.type14Files
        await fileInput.validateFiles().then(() => {
          if (fileInput.isSuccess) {
            this.step = 7
            fileInput.isSuccess = false
          }
        })
      } else {
        this.step = 7
      }
    },

    // Целевое направление
    async fromStep7() {
      if (this.target_agree) {
        const fileInput = this.$refs.type10Files
        await fileInput.validateFiles().then(() => {
          if (fileInput.isSuccess) {
            this.step = 8
            fileInput.isSuccess = false
          }
        })
      } else {
        this.step = 8
      }
    },

    // Согласие на зачисление
    async submit() {
      await this.$store.commit("abiturient/UPDATE_ABITURIENT_MODEL", {
        current_application_id: null,
        current_application_step: 1,
        priority_agree: false,
        target_agree: false,
        progress_agree: false,
      })
      await this.$store.commit("application/CHANGE_APPLICATION", {
        completed: true
      })

      await Promise.all([
        this.$store.dispatch("abiturient/update"),
        this.$store.dispatch("application/updateApplication"),
      ]).finally(() => {
        this.$router.push({name: 'profile_application_list'})
        this.$store.commit("application/RESET_APPLICATION")
      })
    },
  },
};
</script>
